const Colors = {
  green: 'rgb(65, 199, 122)',
  red: 'rgb(242, 59, 105)',
  border: '1px solid rgb(64,73,78)',
  borderColor: 'rgb(64,73,78)',
  // darkBlue: 'hsla(0,0%,100%,.08)',
  darkBlue: 'rgb(26, 32, 41)',
  lightGray: 'rgba(255,255,255,0.6)',
  white: 'hsla(0,0%,100%,.85)',
  headerColor: 'hsla(0,0%,100%,.08)',
  lightBlue: '#90caf9',
  btnDisabled: 'hsla(0,0%,100%,.2)',
}

export default Colors;